import { Button, ButtonGroupProps, Link } from "@chakra-ui/react";
import * as React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useLang } from "../lib/lang";

const LABEL = { pt: "Visitar Site", en: "Visit Website" };

export const SocialMediaLinks = (props: ButtonGroupProps) => {
  const lang = useLang();
  return (
    <Button
      as={Link}
      href="https://xlung.net/"
      isExternal
      colorScheme="red"
      textColor="#FFF"
      leftIcon={<FaExternalLinkAlt />}
      variant="solid"
    >
      {LABEL[lang]}
    </Button>
  );
};
